import React from 'react';

import Cancel from '@mui/icons-material/CancelRounded';
import CheckCircle from '@mui/icons-material/CheckCircleRounded';
import {
  ListItemIcon, Menu, MenuItem,
  Typography,
} from '@mui/material';

interface MoreMenuProps {
  anchor: HTMLElement | null,
  open?: boolean,
  onClose?: () => void,
  userEnabled?: boolean,
  onUserStateToggleClick?: () => void,
}

const MoreMenu = (
  { anchor,
    open = false,
    onClose = () => {},
    userEnabled = false,
    onUserStateToggleClick = () => {} } : MoreMenuProps) =>
  (
    <Menu
      anchorEl={anchor}
      open={open}
      onClose={onClose}
      onClick={onClose}
      disableScrollLock
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem onClick={onUserStateToggleClick} disableRipple>
        <ListItemIcon>
          {userEnabled ? (
            <Cancel fontSize="small" />
          ) : (
            <CheckCircle fontSize="small" />
          )}
        </ListItemIcon>
        <Typography variant="body2">
          {userEnabled ? 'Disable User' : 'Enable User'}
        </Typography>
      </MenuItem>
    </Menu>
  );

export default MoreMenu;
